import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { FAQS_SHOPIFY_DEV } from "@/lib/service-content/faqs/shopify-dev";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/es/desarrollo-shopify";

export const Route = createFileRoute("/es/desarrollo-shopify")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es",
    title: "Agencia de Desarrollo Shopify en México | Shugert",
    description: "Agencia de desarrollo Shopify para México y Latinoamérica: themes, Shopify Plus, apps, integraciones, storefronts y replatforming con ingeniería senior, staging y control de release.",
    path: PATH,
    altPath: alternatePath(PATH, "en"),
    ogImage: "/og-development-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Desarrollo Shopify en México", path: PATH }]),
      faqJsonLd(FAQS_SHOPIFY_DEV.es),
      serviceJsonLd({
        name: "Agencia de Desarrollo Shopify en México",
        description: "Desarrollo Shopify senior para equipos en México y Latinoamérica: themes Online Store 2.0, capacidades soportadas de Plus, apps, integraciones y replatforming controlado.",
        path: PATH,
        serviceType: "Agencia de Desarrollo Shopify",
        minPrice: 1500,
        unit: "PROJECT",
        deliverables: [
          "Brief de arquitectura y ownership",
          "Plan de implementación de alcance fijo",
          "Desarrollo en staging",
          "QA representativo y controles de release",
          "Documentación y handoff técnico",
        ],
        locale: "es",
      }),
      webPageJsonLd({
        name: "Agencia de Desarrollo Shopify en México",
        path: PATH,
        description: "Ingeniería y desarrollo Shopify senior para equipos en México, con arquitectura, staging, validación y handoff explícitos.",
        inLanguage: "es-MX",
      }),
    ],
  }),
});
